import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import SectionHeader from '/component/base/SectionHeader';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
interface ReportMeta {
  page: {
    total: number;
  };
}

interface CoachesListHeaderProps extends WithTranslationProps {
  reportMeta: ReportMeta | null;
  reportName: string;
  reportIsLoading: boolean;
  tt: (key: string, callback?: any) => string;
  tierName: string;
}

export const CoachesListHeader: React.FC<CoachesListHeaderProps> = ({
  tt = withTranslation.ttDefaultProp,
  reportMeta = null,
  reportName = '',
  reportIsLoading = true,
  tierName = '',
}) => {
  const total = Number(get(reportMeta, 'page.total', ''));
  return (
    <SectionHeader
      reportName={reportName}
      reportIsLoading={reportIsLoading}
      tierName={tierName}
      reportMeta={reportMeta}>
      {tt(
        'totalCoachesCount',
        generateComponentCallback({
          component: (
            <>
              {total} {total === 1 ? 'Coach' : 'Coaches'}
            </>
          ),
        }),
      )}
    </SectionHeader>
  );
};

export default withTranslation('report.list.coachesHeader')(CoachesListHeader);
